import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { useActions } from 'hooks/useActions';
import * as AuthActions from 'global/actions/authActions';
import { Modal, Header, Body, Footer, FooterButton } from 'components/Modals/modalElements';
import { TwoFactorAuthenticationContainer, QRImage, Label, TextInput, ErrorMessage } from './styles';

export default React.memo(({ closeModal }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [showQRCode, setShowQRCode] = useState(true);
  const [code, setCode] = useState('');
  const [hasError, setHasError] = useState(false);

  let { QRCode, QRResponse } = useSelector((state) => state.auth);
  const { loadQRCode, setQRCode } = useActions(AuthActions);

  useEffect(() => {
    loadQRCode();
  }, [loadQRCode]);

  useEffect(() => {
    if (!QRResponse?.hasOwnProperty('isSuccessful')) return;
    if (QRResponse.isSuccessful) {
      toast.success('Two Factor authentication activated successfully');
      closeModal();
    } else {
      setHasError(true);
    }
  }, [QRResponse, closeModal]);

  return (
    <Modal isOpen={isOpen}>
      <Header>Enable Two Factor Authentication</Header>
      <Body>
        <Label>
          To activate two factor authentication download Google Authenticator or a similar app, add new account, and
          scan the QR-code. Then press continue to complete the setup.
        </Label>
        <TwoFactorAuthenticationContainer>
          {showQRCode && QRCode && <QRImage src={QRCode} />}
          {!showQRCode && (
            <>
              <TextInput
                value={code}
                isEditing={true}
                placeholder="Enter code*"
                onChange={(e) => setCode(e.target.value)}
              />
              {hasError && <ErrorMessage padding="5px 0 0 0">Invalid code</ErrorMessage>}
            </>
          )}
        </TwoFactorAuthenticationContainer>
      </Body>
      <Footer>
        <FooterButton
          label="Close"
          onClick={() => {
            closeModal();
            setIsOpen(false);
          }}
        />
        <FooterButton
          label={showQRCode ? 'Continue' : 'Activate'}
          onClick={() => {
            if (showQRCode) setShowQRCode(false);
            else setQRCode(code);
          }}
        />
      </Footer>
    </Modal>
  );
});
